module.exports = __webpack_public_path__ + "img/34.1d1c1e3a.jpg";